export const newsData = [
  {
    id: 1,
    title: "RDCA District Championship",
    description: "Ranipet District Championship successfully conducted.",
    image: "/images/news1.jpg",
    content: "Full details about RDCA District Championship.",
    link: "https://example.com/news/ranch-championship",
    date: "2024-01-15"
  },
  {
    id: 2,
    title: "Inter School Chess Meet",
    description: "Young talents showcased excellent skills.",
    image: "/images/news2.webp",
    content: "State level event details.",
    link: "https://example.com/news/inter-school-meet",
    date: "2024-01-10"
  },
  {
    id: 3,
    title: "Junior Chess Competition",
    description: "Young talents showcasing their skills.",
    image: "/images/news3.webp",
    content: "Junior competition full details.",
    link: "https://example.com/news/junior-competition",
    date: "2024-01-05"
  }
];

export const players = [
  { id: 1, name: "Arjun Kumar", photo: "/images/p1.jpg" },
  { id: 2, name: "Divya S", photo: "/images/p2.jpg" },
  { id: 3, name: "Rajesh K", photo: "/images/p3.webp" },
  { id: 4, name: "Suresh P", photo: "/images/p4.jpg" }
];

export const galleryImages = [
  { id: 1, image: "/images/g1.webp" },
  { id: 2, image: "/images/g2.webp" },
  { id: 3, image: "/images/g3.webp" },
  { id: 4, image: "/images/g4.webp" },
  { id: 5, image: "/images/g5.webp" },
  { id: 6, image: "/images/g6.jpeg" },
  { id: 7, image: "/images/g7.jpg" },
  { id: 8, image: "/images/g8.webp" },
  { id: 9, image: "/images/g1.webp" },
  { id: 10, image: "/images/g2.webp" },
  { id: 11, image: "/images/g3.webp" },
  { id: 12, image: "/images/g4.webp" }
];